import { useState } from "react";
import "./Image.scss";
import { ImageType } from "../../../types/app/mediaTypes";
import { Link } from "react-router-dom";
import EditIco from "../../../assets/icons/edit.svg"
import { ActionProps } from "./InAppContent";


type Props = {
    image: ImageType | any;
    isSelected: boolean;
    onSelect: () => void;
    onEdit: () => void;
};

const formatSize = (size?: number) => {
    if (!size || isNaN(size)) return "Unknown size";

    const units = ["bytes", "KB", "MB", "GB", "TB"];
    let unitIndex = 0;
    let displaySize = size;

    while (displaySize >= 1024 && unitIndex < units.length - 1) {
        displaySize /= 1024;
        unitIndex++;
    }

    const roundedSize = unitIndex === 0 ? displaySize : displaySize.toFixed(1);

    return `${roundedSize} ${units[unitIndex]}`;
};

const formatDate = (dateStr?: string) => {
    if (!dateStr) return "Unknown date";
    const date = new Date(dateStr);
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
};

export const ImageCard = ({ image, isSelected, onSelect, onEdit }: Props) => {
    const [loaded, setLoaded] = useState(false);
    const [hasError, setHasError] = useState(false);
    const fileType = image.imageUrl
        ? image.imageUrl.split('.').pop()?.toLowerCase() || 'unknown'
        : 'unknown';


    return (
        <div
            className={`image-card ${isSelected ? "selected" : ""}`}
            onClick={onSelect}
            style={{ width: '176.83px', height: '221px' }}
        >
            <div className="image-wrapper">
                {!loaded && !hasError && <div className="shimmer" />}
                {hasError ? (
                    <div className="error-placeholder">Image not available</div>
                ) : (
                    <img
                        src={image.imageUrl || ""}
                        alt={image.name || "Unnamed"}
                        onLoad={() => setLoaded(true)}
                        onError={() => setHasError(true)}
                        style={{ display: loaded ? "block" : "none" }}
                    />
                )}
                {isSelected && (
                    <div className="checkbox">
                        <span>✔</span>
                    </div>
                )}
            </div>
            <div className="card-info">
                <div className="top">
                    <p className="name">{image.name || "Unnamed"}{!image?.fileName && `.${fileType}`}</p>
                    {/* <Link className="page-Link" to={"#"}> */}
                        <button className="edit-btn" onClick={(e) => { e.stopPropagation(); onEdit(); }}>
                            <img src={EditIco} alt="" width={18} height={18}/>
                        </button>
                    {/* </Link> */}
                </div>
                <div className="bottom">
                    <p className="date">{formatDate(image.createdDate)}</p>
                    <p className="size">{formatSize(image.size)}</p>
                </div>
            </div>
        </div>
    );
};
